<template>
	<div class="tp-RepairView__entry is-history">
		<h4>Historico</h4>

		<RepairHistoryTableReact :logs="orderedLogs" :users="users" />
	</div>
</template>

<script lang="ts">
import Vue from "vue";
import _, { isNil } from "lodash";
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { RepairHistoryTable } from "@/components/repair/history/RepairHistoryTable";

import { ELogsAction } from "@/modules/repairs/services/store/repair/submodules/logs/logs.types";
import type { IRepair } from "@/modules/repairs/types/repair.interface";
import type { ILog } from "@/modules/repairs/types/log.interface";
import { EUsersActions } from "@/services/store/modules/users/users.types";
import type { IUser } from "@/services/store/modules/user-types";

const RepairHistoryTableReact = ReactInVue(RepairHistoryTable);

export default Vue.extend({
	components: {
		RepairHistoryTableReact,
	},

	name: "RepairHistory",

	props: {
		repairId: {
			type: String,
			required: true,
		},
	},

	computed: {
		logs(): Array<ILog> {
			return this.$store.get("repair/logs/logs");
		},

		users(): Array<IUser> {
			return this.$store.get("users/users");
		},

		orderedLogs() {
			return _.orderBy(this.logs, "date", "desc");
		},
	},

	watch: {
		repairId: {
			immediate: true,
			async handler(newId: IRepair) {
				await this.$store.dispatch(ELogsAction.FETCH, newId);
				this.fetchUsers();
			},
		},
	},

	methods: {
		async fetchUsers() {
			const ids = this.logs
				.map((entry) => entry.context.user)
				.filter((id) => !isNil(id));
			this.$store.dispatch(EUsersActions.FETCH_USER, ids);
		},
	},
});
</script>
